import React from 'react';
import startCase from 'lodash/startCase';
import { compose } from 'recompose';
import styled, { StylesProps, cx } from '../../../../../../../lib/styles';
import ArticleFeatureStyles from './ArticleFeature_styles';
import Spacer from '../../../../../../../components/presentational/Spacer';
import { Article } from '../../../../../../../models/article';
import StoryAuthor from '../../../../../../../components/presentational/StoryAuthor';
import Image from '../../../../../../../components/presentational/Image';

export interface ArticleFeatureProps {
  type: string;
  article: Article;
  onClick?: () => any;
  lazy: boolean;
  disableAuthor: boolean;
}

const ArticleFeature = ({
  article,
  disableAuthor,
  onClick,
  lazy = true,
  styles,
}: ArticleFeatureProps & StylesProps<typeof ArticleFeatureStyles>) => (
  <a className={styles.link} href={article.link} onClick={onClick}>
    <div className={styles.featureContainer}>
      <div className={styles.featureImageContainer}>
        <Image
          alt={article.title}
          className={cx(styles.featureimage, 'ArticleFeature__image')}
          src={article.large_image}
          lazy={lazy}
          aspect={[16, 9]}
          resizeWidth={760}
          resizeFit={'crop'}
        />

        <div style={{ position: 'absolute' }}>
          <button>Read more</button>
        </div>
      </div>

      <Spacer className={styles.featuretext} space={'xxs'} align={'flex-start'}>
        <span className={styles.category}>
          {startCase(article.category.toLowerCase())}
        </span>
        <h2 className={cx(styles.featuretitle, 'ArticleFeature__title')}>
          {article.title}
        </h2>

        <Spacer space={'xs'} align={'flex-start'}>
          <span className={styles.subtitle}>{article.excerpt}</span>
          {!disableAuthor && article.author && (
            <StoryAuthor size={'s'} author={article.author} />
          )}
        </Spacer>
      </Spacer>
    </div>
  </a>
);

export default compose(styled(ArticleFeatureStyles))(ArticleFeature);
